import React from 'react'
import Header from '../../components/Header/Header'

const ContactUs = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default ContactUs